export default __webpack_public_path__ + "static/media/assessment_glide_3_1.ff557f7a.svg";